import React from 'react'
import EmailContent from '../components/emails/EmailContent'

const AppsEmail = () => {
    return (
        <>
            <EmailContent />
        </>
    )
}

export default AppsEmail